import { useCallback, useEffect, useRef } from 'react';
import dayjs from 'dayjs';

/**
 * アニメーション用Hook
 * @param isRunning
 * @param callback
 */
export const useAnimationFrame = (isRunning: boolean, callback = (dt: number) => {}) => {
  const reqIdRef = useRef<number | null>(null);
  const lastTimeRef = useRef<number | null>(null);

  const loop = useCallback(() => {
    if (isRunning) {
      reqIdRef.current = requestAnimationFrame(loop);
      const now = dayjs().valueOf();
      const dt = lastTimeRef.current ? (now - lastTimeRef.current) / 1000 : 0;
      if (dt > 0.1) {
        // タブが非アクティブの場合、dt が大きくなるので 0 にする
        callback(0);
        return;
      }
      callback(dt);
    }
  }, [isRunning, callback]);

  useEffect(() => {
    lastTimeRef.current = dayjs().valueOf();
    reqIdRef.current = requestAnimationFrame(loop);
    return () => {
      lastTimeRef.current = null;
      cancelAnimationFrame(reqIdRef.current);
    };
  }, [loop]);
};
